import React, { useCallback, useEffect, useState } from "react";
import { settings } from "app";
import { Datagrid, DateField, FunctionField, TextField } from "react-admin";
import { Typography } from "@mui/material";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";
import ChangeGradeModal from "components/Users/Students/Modals/ChangeGrade";
import GradeHistoryModal from "components/Users/Students/Modals/GradeHistoryModal";

const SemesterGrades = ({ studentEducationId, disciplineId }) => {
  const [grades, setGrades] = useState([]);

  const fetchGrades = useCallback(async () => {
    if (!studentEducationId || !disciplineId) return;
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getStudentDisciplineGrade(studentEducationId, disciplineId),
        null,
        "GET",
      );
      setGrades(data ? [{ ...data, courses: data.courses?.join(", ") }] : []);
    } catch (err) {
      console.error("Error fetching semester grades", err);
      setGrades([]);
    }
  }, [studentEducationId, disciplineId]);

  useEffect(() => {
    fetchGrades();
  }, [fetchGrades]);

  return (
    <>
      <Typography
        color="primary"
        sx={{ mb: 1 }}
      >
        Семестриална оценка
      </Typography>
      <Datagrid
        data={grades}
        resource="semesterGrades"
        bulkActionButtons={false}
        rowClick={false}
        sx={[settings.style.detailsDatagrid, { "& .RaDatagrid-headerCell": { textAlign: "left" } }, { mb: 1 }]}
      >
        <TextField
          source="disciplineTypeLabel"
          label="Тип"
          sortable={false}
        />
        <TextField
          source="courses"
          label="Курс"
          sortable={false}
          emptyText="-"
        />
        <TextField
          source="grade"
          label="Оценка"
          sortable={false}
          emptyText="-"
        />
        <DateField
          source="gradedOn"
          label="Дата на оценка"
          locales="bg-BG"
          sortable={false}
        />
        <FunctionField
          label="История на оценки"
          render={rec => (
            <GradeHistoryModal
              id={studentEducationId}
              record={rec}
            />
          )}
        />
        <SecuredComponent
          permission={permissions.canManageStudentsAllDisciplinesGrades}
          label="Редакция на оценка"
        >
          <FunctionField
            render={rec => (
              <ChangeGradeModal
                record={rec}
                educationId={studentEducationId}
                fetchGrades={fetchGrades}
              />
            )}
          />
        </SecuredComponent>
      </Datagrid>
    </>
  );
};

export default SemesterGrades;
